import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { from, merge, Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { Offer } from 'src/models/Offer';
import { Retailer } from 'src/models/Retailer';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-offers-list',
  templateUrl: './offers-list.component.html',
  styleUrls: ['./offers-list.component.scss']
})
export class OffersListComponent implements OnInit, AfterViewInit, OnChanges {

  displayedColumns: string[] = ['displayName', 'startDate', 'endDate'];
  filteredAndPaged: Observable<Offer[]>;
  private sub: any;
  resultsLength = 0;
  isLoadingResults = true;
  @Input() retailer : Retailer;
  @Input() offers : Offer[] = []
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private route: ActivatedRoute, private api: ApiService) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.ngAfterViewInit();
  }

  retailer_location_id: string;
  ngAfterViewInit() {
    console.log("doin stuff");
    this.filteredAndPaged = merge(this.sort.sortChange, this.paginator.page)
        .pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              console.log("will bind list to ");
              console.log(this.offers);
              return of(this.offers);
              //this.api.getOffersForRetailer(this.retailer_location_id, this.sort.active, this.sort.direction=='desc', this.paginator.pageSize, this.paginator.pageIndex)
            }),
            map(data => {
              this.isLoadingResults = false; 
              return data;
            }),
            catchError(e => {
              //todo: error msg
              this.isLoadingResults = false;
              return of([]);
            })
        )
  }
  resetPaging(): void {
    this.paginator.pageIndex = 0;
  }
  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      this.retailer_location_id = params['location_id'];
   });
  }

}
